import { gql } from '@apollo/client';

export const CREATE_PENDING_EXPORT_MUTATOR = gql`
  mutation createPendingExportMutator(
    $group_id: String
    $company_id: String
    $export_type_id: String
    $user_info: JSON
  ) {
    createPendingExport_archived_1757533192(
      group_id: $group_id
      company_id: $company_id
      export_type_id: $export_type_id
      user_info: $user_info
    )
  }
`;
